import React from "react";
import "./Button.scss";

const Button = ({
  children,
  onClick,
  variant = "primary",
  type = "button",
  disabled = false,
  ariaLabel,
  ariaDescribedBy,
  className = "",
  ...props
}) => {
  const buttonClasses = `button button--${variant} ${className}`.trim();

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
